import { render, staticRenderFns } from "./NewOrderView.vue?vue&type=template&id=d2d23310"
import script from "./NewOrderView.vue?vue&type=script&lang=js"
export * from "./NewOrderView.vue?vue&type=script&lang=js"
import style0 from "./NewOrderView.vue?vue&type=style&index=0&id=d2d23310&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports